import {useEffect, useState} from "react";
import GameDescription from "./description";
import GeneralStatsItem from "../../components/game-stats/item";
import associateServices from "../../services";
import NoData from "../../components/no-data";
import Loading from "../../components/loading";
import {useTranslation} from "react-i18next";
import {Link, useSearchParams} from "react-router-dom";
import SvgIcon from "../../components/svg-icon";
import stringHelper from "../../helpers/string-helper";
import {useSelector} from "react-redux";
import ChallengeTable from "./challenge-table";

let infoTypes = ['description', 'big-wins', 'lucky-wins', 'challenges']
const GameInfo = props => {

    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {game, isMobile = false} = props

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [loading, setLoading] = useState(true)
    const [activeType, setActiveType] = useState('description')
    const [data, setData] = useState([])


    useEffect(() => {
        if (isMobile) {
            infoTypes = ['big-wins', 'lucky-wins', 'challenges']
            setActiveType('big-wins')
        }
    }, [isMobile])
    const handleApiResponse = res => {
        setData(res?.data || [])
        setLoading(false)
    }
    useEffect(() => {
        if (game?.id && ['big-wins', 'lucky-wins', 'challenges'].includes(activeType)) {
            setLoading(true)
            associateServices.getCasinoGameDebits({
                type: activeType,
                limit: 10,
                game_id: game?.id
            }).then(handleApiResponse)
        }
    }, [activeType, game])

    const [searchParams, setSearchParams] = useSearchParams()
    const handleBetDetail = bet => {
        console.log('bet = ', bet)
        searchParams.append('modal', 'bet')
        searchParams.append('reference', `${bet.type ?? 'casino'}:${bet.id}`)
        setSearchParams(searchParams)
    }


    const handleUserDetail = bet => {

        if (!bet?.customer?.is_public)
            return false

        searchParams.append('modal', authenticated ? 'statistics' : 'login')
        if (authenticated)
            searchParams.append('user', bet?.customer?.username)

        setSearchParams(searchParams)


    }


    return (
        <div className="col-12">
            <div className="game">
                <div className="game__head">
                    <h1 className="game__title">{game?.name}</h1>
                    <Link
                        to={stringHelper.getLocalizedPath(currentLanguage, `/providers/${game?.game_provider?.identifier}`)}
                        className="game__group">
                        {game?.provider || '-'}
                    </Link>
                    {/*<p className="game__rate">*/}
                    {/*    <b>1st</b>*/}
                    {/*    <i className="ti ti-trophy"/>13 681.65*/}
                    {/*</p>*/}
                    <button
                        className="game__more"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseGame"
                        aria-expanded="false"
                        aria-controls="collapseGame"
                    >
                        <SvgIcon id={'right-down'}/>
                    </button>
                </div>
                <div className="game__collapse collapse" id="collapseGame">
                    <div className="game__tabs">
                        <ul
                            className="nav nav-tabs tabs-nav"
                        >
                            {
                                infoTypes?.map(infoType => (
                                    <li className="nav-item" role="presentation" key={infoType}>
                                        <button
                                            onClick={e => setActiveType(infoType)}
                                            className={`tabs-nav__btn ${activeType === infoType ? 'active' : ''}`}
                                            type="button"
                                        >
                                            {t(`stats.types.${infoType}`)}
                                        </button>
                                    </li
                                    >

                                ))
                            }
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div
                            className="tab-pane fade show active">
                            {
                                activeType === 'description'
                                    ? <GameDescription game={game}/> :
                                    activeType === 'challenges' ?
                                        <ChallengeTable gameName={game?.name} data={data}/>
                                        :
                                        data?.length <= 0 ? <NoData/> :

                                            loading ? <Loading/> :
                                                <div className="table-responsive">
                                                    <table className="xtable">
                                                        <thead>
                                                        <tr>
                                                            <th>{t('stats.table.game')}</th>
                                                            <th>{t('stats.table.user')}</th>
                                                            <th>{t('stats.table.time')}</th>
                                                            <th>{t('stats.table.bet')}</th>
                                                            <th>{t('stats.table.multiplier')}</th>
                                                            <th>{t('stats.table.profit')}</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data?.map((stat, o) => <GeneralStatsItem stat={stat}
                                                                                                     handleBetDetail={handleBetDetail}
                                                                                                     handleUserDetail={handleUserDetail}
                                                                                                     o={o}
                                                                                                     key={o}/>)
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>

                            }
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )

}

export default GameInfo
